<script type="text/ecmascript-6">
    import DesignerQuestionHardwareHandleSlave from "../DesignerQuestionHardwareHandleSlave.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareHandleSlave
        ],
        props: {
            title: {
                default() {
                    return 'Select Your Door Handle';
                }
            }
        }
    }
</script>
